export default __webpack_public_path__ + "assets/950006.png";